<div *ngIf="assetTemplate && assetInstance" fxLayoutGap="10px" [ngClass]="assetDepth > 0 ? 'asset-instance-border' : 'm-r-15'">

  <div *ngFor="let templateProp of assetTemplate!.properties" class="m-r-0" fxLayout="column" fxLayoutAlign="start start">
    <div *ngIf="showProperty(templateProp)" class="property">
      <small [matTooltip]="propertyTypeName(templateProp)">{{ templateProp.propertyName }}:</small>

      <ng-container *ngIf="templateProp.assetCount === 1; else hasMultipleAssetCount" [ngTemplateOutlet]="template_property" [ngTemplateOutletContext]="{templateProp:templateProp, valueCollection:assetInstance.values, valueKey:templateProp.propertyName}"></ng-container>
      
      <ng-template #hasMultipleAssetCount>
        <ng-container [ngTemplateOutlet]="property_collection" [ngTemplateOutletContext]="{templateProp:templateProp, propertyCollection:assetInstance.values[templateProp.propertyName], propertyName: templateProp.propertyName}"></ng-container>
      </ng-template>
    </div>
  </div>

  <div *ngIf="!showAllProperties" class="m-r-0" fxLayout="row" fxLayoutAlign="center center">
    <button type="button" mat-flat-button color="basic" (click)="showAllProperties = true">
      Show All Properties
    </button>
  </div>
  
</div>

<ng-template #template_property let-templateProp='templateProp' let-valueCollection='valueCollection' let-valueKey='valueKey'>
  <ng-container [ngSwitch]="templateProp.assetType">
    
    <!-- String -->
    <ng-container *ngSwitchCase="propertyType.STRING">
      <mat-form-field>
        <textarea matInput *ngIf="templateProp.propertyName === 'Notes'; else otherText" [(ngModel)]="valueCollection[valueKey]" (ngModelChange)="onPropertyEdited(templateProp, valueCollection[valueKey])"></textarea>
        
        <ng-template #otherText>
          <input matInput [(ngModel)]="valueCollection[valueKey]" (ngModelChange)="onPropertyEdited(templateProp, valueCollection[valueKey])" />
        </ng-template>
      </mat-form-field>
    </ng-container>

    <!-- Integer -->
    <ng-container *ngSwitchCase="propertyType.INT">
      <mat-form-field>
        <input matInput type="number" (keydown)="blockArrowKeys($event)" [(ngModel)]="valueCollection[valueKey]" (ngModelChange)="onPropertyEdited(templateProp, valueCollection[valueKey])" />
      </mat-form-field>
    </ng-container>

    <!-- Float -->
    <ng-container *ngSwitchCase="propertyType.FLOAT">
      <mat-form-field>
        <input matInput type="number" step="0.001" (keydown)="blockArrowKeys($event)" [(ngModel)]="valueCollection[valueKey]" (ngModelChange)="onPropertyEdited(templateProp, valueCollection[valueKey])" />
      </mat-form-field>
    </ng-container>

    <!-- Boolean -->
    <ng-container *ngSwitchCase="propertyType.BOOL">
      <mat-checkbox class="m-l-10 m-b-10" [(ngModel)]="valueCollection[valueKey]" (ngModelChange)="onPropertyEdited(templateProp, valueCollection[valueKey])" >
      </mat-checkbox>
    </ng-container>

    <!-- Enum -->
    <ng-container *ngSwitchCase="propertyType.ENUM">
      <mat-form-field>
        <mat-select [(ngModel)]="valueCollection[valueKey]" (ngModelChange)="onPropertyEdited(templateProp, valueCollection[valueKey])" >
          <mat-option *ngFor="let option of getEnumOptions(templateProp.enumValues)" [value]="option">
            {{ option }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>

    <!-- Image Asset Resource -->
    <ng-container *ngSwitchCase="propertyType.IMAGE">
      <div class="m-r-0 w-100" fxLayout="column" fxLayoutAlign="start start">
        <ng-container [ngTemplateOutlet]="asset_instance" [ngTemplateOutletContext]="{templateProp:templateProp, assetProperty:valueCollection[valueKey]}"></ng-container>
      </div>
    </ng-container>

    <!-- Mesh Asset Resource -->
    <ng-container *ngSwitchCase="propertyType.MESH">
      <div class="m-r-0 w-100" fxLayout="column" fxLayoutAlign="start start">
        <ng-container [ngTemplateOutlet]="asset_instance" [ngTemplateOutletContext]="{templateProp:templateProp, assetProperty:valueCollection[valueKey]}"></ng-container>
      </div>
    </ng-container>

    <!-- Blender Asset Resource -->
    <ng-container *ngSwitchCase="propertyType.BLENDER">
      <div class="m-r-0 w-100" fxLayout="column" fxLayoutAlign="start start">
        <ng-container [ngTemplateOutlet]="asset_instance" [ngTemplateOutletContext]="{templateProp:templateProp, assetProperty:valueCollection[valueKey]}"></ng-container>
      </div>
    </ng-container>

    <!-- Editable Template -->
    <ng-container *ngSwitchCase="propertyType.TEMPLATE">
      <div class="m-r-0" fxLayout="column" fxLayoutAlign="start start">
        <ng-container [ngTemplateOutlet]="asset_instance" [ngTemplateOutletContext]="{templateProp:templateProp, assetProperty:valueCollection[valueKey]}"></ng-container>
      </div>
    </ng-container>

    <!-- File -->
    <ng-container *ngSwitchCase="propertyType.FILE">
      <div>
        {{ valueCollection[valueKey]?.callerReferenceKey || valueCollection[valueKey] || 'Not Set' }}
      </div>
    </ng-container>

  </ng-container>

</ng-template>

<ng-template #property_collection let-templateProp='templateProp' let-propertyCollection='propertyCollection' let-propertyName='propertyName'>
  <ng-container *ngIf="propertyCollection" [ngTemplateOutlet]="property_array" [ngTemplateOutletContext]="{templateProp:templateProp, propertyArray:propertyCollection, propertyName:propertyName}"></ng-container>

  <div *ngIf="!propertyCollection">
    <i class="property">Not Set</i>
  </div>

  <div class="property" fxLayout="row" fxLayoutAlign="start center">
    <small>Add/Remove Item</small>
    <button mat-icon-button (click)="addNewItemToCollection(propertyCollection, propertyName); onPropertyEdited(templateProp, propertyCollection)" matTooltip="Add New Item To Collection">
      <mat-icon>add</mat-icon>
    </button>
    <button mat-icon-button (click)="removeItemFromCollection(propertyCollection); onPropertyEdited(templateProp, propertyCollection)" matTooltip="Remove Item From Collection">
      <mat-icon>remove</mat-icon>
    </button>
  </div>
</ng-template>


<ng-template #property_array let-templateProp='templateProp' let-propertyArray='propertyArray' let-propertyName='propertyName'>
  <div *ngIf="propertyArray.length === 0" class="property">
    <i>Empty Collection</i>
  </div>
  <div class="property">
    <ng-container *ngFor="let value of propertyArray; let i=index">
      <small *ngIf="value['key']" style="word-wrap: break-word;">{{ value['key'] }}:</small>

      <ng-container *ngIf="!isArray(value['value'] ?? value); else valueIsArray" [ngTemplateOutlet]="template_property" [ngTemplateOutletContext]="{templateProp:templateProp, valueCollection:propertyArray, valueKey:i}"></ng-container>
      <ng-template #valueIsArray>
        <ng-container [ngTemplateOutlet]="property_array" [ngTemplateOutletContext]="{templateProp:templateProp, propertyArray:value['value'] ?? value, propertyName:propertyName}"></ng-container>
      </ng-template>
    </ng-container>
  </div>

</ng-template>

<ng-template #asset_instance let-templateProp='templateProp' let-assetProperty='assetProperty'>
  <ng-container *ngIf="assetProperty && assetProperty['values']; else isAssetReference" [ngTemplateOutlet]="embedded_asset_instance" [ngTemplateOutletContext]="{templateProp:templateProp, assetProperty:assetProperty}"></ng-container>
  <ng-template #isAssetReference>
    <ng-container [ngTemplateOutlet]="asset_reference_value_property" [ngTemplateOutletContext]="{templateProp:templateProp, assetProperty:assetProperty}"></ng-container>
  </ng-template>
</ng-template>

<ng-template #embedded_asset_instance let-templateProp='templateProp' let-assetProperty='assetProperty'>
  <div class="m-r-0 w-100" fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="column" fxLayoutAlign="start start">
      <small *ngIf="assetProperty?.name ?? assetProperty.values.Name">{{ assetProperty?.name ?? assetProperty.values.Name }}</small>
      <i>Embedded {{ templateProp.templateName }} Asset</i>
    </div>
    
    <div fxLayout="row" fxLayoutAlign="end center">
      <ng-container [ngTemplateOutlet]="asset_buttons" [ngTemplateOutletContext]="{templateProp:templateProp, assetProperty:assetProperty}"></ng-container>
    </div>
  </div>
  
  <ng-container *ngIf="shouldShowAssetInstance(assetProperty)">
    <artifact-tree class="w-100"
    [product]="product"
    [productCompany]="productCompany"
    [assetInstanceKey]="assetInstanceKey"
    [assetInstance]="assetProperty"
    [assetTemplateKey]="assetProperty.templateID"
    [assetInstances]="assetInstances"
    [assetTemplates]="assetTemplates"
    [assetDepth]="assetDepth + 1"
    (findAndReplaceAssetReference)="findAndReplaceAssetReference.emit($event)"
    (propertyEdited)="propertyEdited.emit($event)"
    >
    </artifact-tree>
  </ng-container>

</ng-template>

<ng-template #asset_reference_value_property let-templateProp='templateProp' let-assetProperty='assetProperty'>
  <div class="m-r-0 w-100 asset-reference-value-property" fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="column" fxLayoutAlign="start start">
      <small *ngIf="assetProperty?.name">{{ assetProperty?.name }}</small>
      <span class="caller-reference-key" *ngIf="assetProperty?.callerReferenceKey">{{ assetProperty.callerReferenceKey }}</span>
      <i *ngIf="!assetProperty?.callerReferenceKey">Not Set</i>
    </div>
    
    <div fxLayout="row" fxLayoutAlign="end center">
      <ng-container [ngTemplateOutlet]="asset_buttons" [ngTemplateOutletContext]="{templateProp:templateProp, assetProperty:assetProperty}"></ng-container>
    </div>
  </div>

  <ng-container *ngIf="shouldShowAssetInstance(assetProperty)">
    <artifact-tree class="w-100"
    [product]="product"
    [productCompany]="productCompany"
    [assetInstanceKey]="assetProperty.callerReferenceKey"
    [assetInstances]="assetInstances"
    [assetTemplates]="assetTemplates"
    [assetDepth]="assetDepth + 1"
    (findAndReplaceAssetReference)="findAndReplaceAssetReference.emit($event)"
    (propertyEdited)="propertyEdited.emit($event)"
    >
    </artifact-tree>
  </ng-container>


</ng-template>

<ng-template #asset_buttons let-templateProp='templateProp' let-assetProperty='assetProperty'>
        <button mat-icon-button color="accent" *ngIf="!shouldShowAssetInstance(assetProperty)" [disabled]="!canShowAssetInstance(assetProperty)" (click)="toggleShowAssetInstance(assetProperty)" matTooltip="Load Asset Details">
        <mat-icon>visibility</mat-icon>
      </button>
      <button mat-icon-button color="accent" *ngIf="shouldShowAssetInstance(assetProperty)" [disabled]="!canShowAssetInstance(assetProperty)" (click)="toggleShowAssetInstance(assetProperty)" matTooltip="Hide Asset Details">
        <mat-icon>visibility_off</mat-icon>
      </button>
      <button mat-icon-button color="accent" [disabled]="!templateProp" (click)="onFindAndReplaceAssetReference(templateProp, assetProperty)" matTooltip="Find and Replace Asset">
        <mat-icon>find_replace</mat-icon>
      </button>
      <button mat-icon-button color="accent" [disabled]="!(assetProperty?.callerReferenceKey || assetProperty?.['values']) || assetProperty?.callerReferenceKey === 'NA'" (click)="clearAsset(assetProperty); onPropertyEdited(templateProp, assetProperty)" matTooltip="Clear Asset">
        <mat-icon>close_small</mat-icon>
      </button>
</ng-template>